import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  activationUrl: string;
  expiresAt: string;
}

export function InvitationLinkDialog({ open, onOpenChange, activationUrl, expiresAt }: Props) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(activationUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Aktivasyon Linki</DialogTitle>
          <DialogDescription>
            Bu link {format(new Date(expiresAt), 'd MMMM yyyy HH:mm', { locale: tr })} tarihine
            kadar geçerli. Müşteriye iletin — şifre belirleyip giriş yapabilir.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <Input value={activationUrl} readOnly onFocus={(e) => e.currentTarget.select()} />
          <Button type="button" variant="outline" onClick={copy} className="shrink-0">
            {copied ? <Check className="h-4 w-4 text-emerald-600" /> : <Copy className="h-4 w-4" />}
            {copied ? 'Kopyalandı' : 'Kopyala'}
          </Button>
        </div>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Kapat</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
